import { TextField, Autocomplete } from "@mui/material";
import { FilterLayout } from "../layout/FilterLayout";
import Button from "../ui/Button";
import { Controller, useForm } from "react-hook-form";
import useAuthUser from "../../hooks/useAuthUser";
import { useEffect, useState } from "react";
import {
  getActiveUsers,
  getReporteeUserHierarchy,
} from "../../services/organizationHierarchy";

const HierarchyFilter = ({ fetchData, setHighlightedUserId }) => {
  const { loggedInUser } = useAuthUser();
  const loggedInUserId = Number(loggedInUser?.id) || null;
  const loggedInUserRole = Number(loggedInUser?.role);
  const isManagerRole =
    loggedInUserRole === 5 || loggedInUserRole === 4 || loggedInUserRole === 8;
  const { control, handleSubmit, reset, watch } = useForm({
    defaultValues: {},
  });
  const [users, setUsers] = useState([]);

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        if (isManagerRole) {
          const res = await getReporteeUserHierarchy();
          setUsers(res.data.data.hierarchy);
        } else {
          const res = await getActiveUsers();
          setUsers(res.data.data);
        }
      } catch (error) {
        console.error("Failed to fetch users:", error);
      }
    };
    fetchUsers();
  }, []);

  const onSubmit = async (data) => {
    try {
      let userId = data.empId ? data.empId : null;
      // if (!userId) return;
      if (!userId) {
        userId = loggedInUserId;
      }
      setHighlightedUserId(userId);
      await fetchData(userId);
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  const handleClear = async () => {
    reset({
      empId: null,
    });
    setHighlightedUserId(loggedInUserId);
    try {
      await fetchData();
    } catch (error) {
      console.error("API call failed:", error);
    }
  };

  return (
    <FilterLayout>
      <form onSubmit={handleSubmit(onSubmit)} className="hierarchy-filter">
        <div className="row">
          <div className="col-lg-4 col-md-5 col-sm-8 col-xs-12">
            <Controller
              name="empId"
              control={control}
              render={({ field }) => (
                <Autocomplete
                  {...field}
                  options={users}
                  getOptionLabel={(option) =>
                    `${option._FirstName} ${option._LastName} (${option._UserEmployeeID})`
                  }
                  value={
                    users.find((user) => user._UserID === watch("empId")) ||
                    null
                  }
                  onChange={(_, value) => {
                    field.onChange(value?._UserID);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Employee Name (Code)"
                      variant="outlined"
                      size="small"
                      fullWidth
                      sx={{
                        backgroundColor: "white",
                      }}
                    />
                  )}
                />
              )}
            />
          </div>

          <div className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
            <Button type="submit" variant="success">
              Filter
            </Button>
            <Button
              type="button"
              variant="dark"
              onClick={handleClear}
              style={{ marginLeft: "5px" }}
            >
              Clear
            </Button>
          </div>
        </div>
      </form>
    </FilterLayout>
  );
};

export default HierarchyFilter;
